export function hasCommentsForPage(codeConversationsContainer: HTMLElement | null, pageId: string) {
  if (!codeConversationsContainer) {
    return false;
  }

  const hasPageComments = Array.from(
    codeConversationsContainer.querySelectorAll('[data-allspice-subpath]'),
    (el) => el.getAttribute('data-allspice-subpath'),
  ).includes(pageId);

  return hasPageComments;
}
